import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseAPIService } from '../base.api.service';

@Injectable()
export class CityService extends BaseAPIService {

    private ROUTES = {
        countryList: '/cities/country',
    };

    constructor(protected http: HttpClient) {
        super(http);
    }

    getCountries(): Promise<any> {
        return this.GET(this.ROUTES.countryList).toPromise();
    }
}
